import { render, staticRenderFns } from "./PresentingComplaintsCard.vue?vue&type=template&id=0fb9817a&scoped=true&"
import script from "./PresentingComplaintsCard.vue?vue&type=script&lang=js&"
export * from "./PresentingComplaintsCard.vue?vue&type=script&lang=js&"
import style0 from "./PresentingComplaintsCard.vue?vue&type=style&index=0&id=0fb9817a&prod&scoped=true&lang=css&"
import style1 from "./PresentingComplaintsCard.vue?vue&type=style&index=1&id=0fb9817a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb9817a",
  null
  
)

export default component.exports